import React, { useState } from 'react'
import IconButton from '@material-ui/core/IconButton'
import { MdModeEdit } from 'react-icons/md'

import DeleteForever from '@material-ui/icons/DeleteForever'
import useMediaPath from 'hooks/useMediaPath'
import DeleteForm from '../Forms/Delete'
import EditForm from '../Forms/Edit'
import styles from '../vehicleType.module.scss'
import './type.scss'
import PreviewComponent from 'components/Global/Preview'

const Vehicletypes = ({ setMessages, data, loading, update }) => {
  const [deleteForm, setDeleteForm] = useState(false)
  const [editForm, setEditForm] = useState(false)
  const [typeId, setTypeId] = useState()

  const mediaPath = useMediaPath()
  return (
    <div className={styles.content}>
      {data &&
        data.map((type, i) => (
          <div className={styles.cardWrapper} key={i}>
            <PreviewComponent
              title={type.vehicleType}
              preview={mediaPath(type.icon.image)}
              componentType="thumbnail"
              previewSize={[200, 200]}
              iconCardWidth={180}
              previewSvgColor="light"
              actions={[
                <IconButton
                  color="secondary"
                  onClick={() => {
                    setEditForm(true)
                    setTypeId(i)
                  }}
                >
                  <MdModeEdit />
                </IconButton>,
                <IconButton
                  color="secondary"
                  onClick={() => {
                    setDeleteForm(true)
                    setTypeId(i)
                  }}
                >
                  <DeleteForever />
                </IconButton>,
              ]}
            />
          </div>
        ))}
      {deleteForm && (
        <DeleteForm
          open={deleteForm}
          setOpen={setDeleteForm}
          type={data[typeId]}
          update={update}
          loading={loading}
        />
      )}
      {editForm && (
        <EditForm
          open={editForm}
          setOpen={setEditForm}
          type={data[typeId]}
          update={update}
          loading={loading}
        />
      )}
    </div>
  )
}

export default Vehicletypes
